// NPM Imports
import React, { useEffect, useState } from "react";

// Components Imports
import RevvEditorRadio from "./RevvEditorRadio";
// Actions Imports

// Internal Imports

export default function RevvEditorRadioField({
  id,
  options,
  display,
  isMagicLinkPage,
  fieldValue,
  isDocInFinalStage,
  isDisabled,
  updateField,
  sectionId,
  className,
  isReadOnly,
  inputFieldStyles,
}) {
  // local states
  const [radioValue, handleRadio] = useState(fieldValue);

  // CDM
  useEffect(() => {
    handleRadio(fieldValue);
  }, [fieldValue]);

  const _handleRadioField = value => {
    if (!isDisabled && !isDocInFinalStage && !isMagicLinkPage && !isReadOnly) {
      handleRadio(value);
      updateField(value === "Other " ? "Other : " : value, "RADIO");
    }
  };

  return (
    Array.isArray(options) &&
    options.map((option, index) => (
      <>
        {/* ------ Checkbox as a checkbox input field ------ */}
        {display.show === "all" && (
          <RevvEditorRadio
            key={`${id}_${option}_${sectionId}`}
            radioId={`${id}_${index}_${sectionId}`}
            option={option}
            isDisabled={isDisabled}
            handleRadioField={_handleRadioField}
            fieldName={`radio_field_${id}_${sectionId}`}
            fieldValue={radioValue}
            isReadOnly={isReadOnly}
            className={className}
            inputFieldStyles={inputFieldStyles}
          />
        )}
        {/* ------ Radio as a only text field ------ */}
        {display.show === "selected" && (
          <span
            contentEditable={false}
            className={`${
              display.direction === "vertical"
                ? "vertically-aligned-cfield"
                : ""
            }`}>
            {`${option}${
              index !== options.length - 1 && display.direction === "horizontal"
                ? ", "
                : ""
            } `}
          </span>
        )}
      </>
    ))
  );
}
